import React, { useState, useEffect } from 'react';
import './orders.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SelectCustom from '../../components/selectCustom/SelectCustom';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import ArrowBack from '../../svg/ArrowBack';
import ArrowNext from '../../svg/ArrowNext';
import Cookies from 'js-cookie';
import axios from 'axios';
import Skeleton from '@mui/material/Skeleton';
import { useQuery } from 'react-query';
import config from '../../config';

const fetchUserData = async (activeUserId, activePage, selectedSort) => {
  if (!activeUserId) {
    return null;
  }
  const url = `${config.apiBaseUrl}admins/users/${activeUserId}/orders`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('authToken')}`
  };
  const skip = activePage * 20 - 20;
  const params = {
    skip: skip,
    limit: 20,
    sort: JSON.stringify(selectedSort)
  };
  const response = await axios.get(url, { headers, params });
  return response.data;
};

const fetchStatData = async (activeUserId) => {
  if (!activeUserId) {
    return null;
  }
  const url = `${config.apiBaseUrl}admins/users/${activeUserId}/orders-statistic`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('authToken')}`
  };
  const response = await axios.get(url, { headers });
  return response.data;
};

const Orders = ({ activeUserId }) => {
  const [total, setTotal] = useState('0');
  const pages = Math.ceil(total / 20);
  const [activePage, setActivePage] = useState(1);

  const handlePageChange = (event, page) => {
    setActivePage(page);
  };

  const [rows, setRows] = useState([]);
  function createData(newOrder, id, img, imgStatus, name, amount, date, sales, source, payment) {
    return { newOrder, id, img, imgStatus, name, amount, date, sales, source, payment };
  }

  const sorts = [{ value: 'createdAt', label: 'Created Date' }];

  const defaultValue = { value: 'createdAt', label: 'Created Date' };

  const [selectedSort, setSelectedSort] = useState({ [defaultValue.value]: 'desc' });

  const handleSelectChange = (selectedOption) => {
    if (
      selectedOption.value == 'price' ||
      selectedOption.value == 'oldPrice' ||
      selectedOption.value == 'title'
    ) {
      setSelectedSort({ [selectedOption.value]: 'asc' });
    } else {
      setSelectedSort({ [selectedOption.value]: 'desc' });
    }
  };

  const [preOrder, setPreOrder] = useState('');
  const [awaitingPayment, setAwaitingPayment] = useState('');
  const [paid, setPaid] = useState('');
  const [delivery, setDelivery] = useState('');
  const [completed, setCompleted] = useState('');
  const [canceled, setCanceled] = useState('');
  const [sales, setSales] = useState('');
  const [currency, setCurrency] = useState('');

  function getStats() {
    const url = `${config.apiBaseUrl}admins/users/${activeUserId}/orders-statistic`;

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };

    axios
      .get(url, { headers })
      .then((response) => {
        setPreOrder(response.data.preOrder);
        setAwaitingPayment(response.data.awaitingPayment);
        setPaid(response.data.paid);
        setDelivery(response.data.delivery);
        setCompleted(response.data.completed);
        setCanceled(response.data.canceled);
        setSales(response.data.sales);
      })
      .catch((error) => {});
  }

  function getUsers() {
    const url = `${config.apiBaseUrl}admins/users/${activeUserId}/orders`;

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };

    const skip = activePage * 20 - 20;
    const params = {
      skip: skip,
      limit: 20,
      sort: JSON.stringify(selectedSort)
    };

    axios
      .get(url, { headers, params })
      .then((response) => {
        setTotal(response.data.total);
        const data = response.data.items.map((order) => {
          setCurrency(order.currency);
          let image = '';
          let imgStatus = false;
          let description = '';
          let price = order.amount;
          let currencySymbol = order.currency;
          if (order.offer) {
            if (order.offer.image) {
              image = order.offer.image;
              imgStatus = true;
            }
            if (order.offer.description) {
              description = order.offer.description;
            }
            if (order.offer.price) {
              price = order.offer.price;
              currencySymbol = order.offer.currencySymbol;
            }
          }

          const inputDateString = order.createdAt;
          const inputDate = new Date(inputDateString);
          const formattedDate = `${inputDate.getDate()}.${(inputDate.getMonth() + 1).toString().padStart(2, '0')}.${inputDate.getFullYear()}`;
          return createData(
            true,
            '',
            image,
            imgStatus,
            description,
            `${currencySymbol}${price}`,
            formattedDate,
            order.statusPipeline,
            'Facebook',
            order.paymentPlatform
          );
        });
        setRows(data);
      })
      .catch((error) => {});
  }

  const {
    isLoading: isLoading,
    error: error,
    data: ordersData
  } = useQuery(['ordersData', activeUserId, activePage, selectedSort], () =>
    fetchUserData(activeUserId, activePage, selectedSort)
  );
  const {
    isLoading: ordersStatLoading,
    error: statError,
    data: ordersStatData
  } = useQuery(['ordersStatData', activeUserId], () => fetchStatData(activeUserId));
  const [showBlock, setShowBlock] = useState(true);

  const rowsLoading = [
    createData(
      true,
      '#6',
      'p1.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#5',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#4',
      '',
      false,
      'Delicious wedding catering services for your special day in NYC',
      '$0.00',
      '13.08.2023',
      'Pre order',
      'Facebook',
      'Invoice'
    ),
    createData(
      false,
      '#3',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#2',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#1',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#6',
      'p1.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#5',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#4',
      '',
      false,
      'Delicious wedding catering services for your special day in NYC',
      '$0.00',
      '13.08.2023',
      'Pre order',
      'Facebook',
      'Invoice'
    ),
    createData(
      false,
      '#3',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#2',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#1',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#6',
      'p1.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#5',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#4',
      '',
      false,
      'Delicious wedding catering services for your special day in NYC',
      '$0.00',
      '13.08.2023',
      'Pre order',
      'Facebook',
      'Invoice'
    ),
    createData(
      false,
      '#3',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#2',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      false,
      '#1',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#6',
      'p1.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    ),
    createData(
      true,
      '#5',
      'p2.jpg',
      true,
      'Delicious wedding catering services for your special day in NYC',
      '$1.19',
      '13.08.2023',
      'Awating Payment',
      'Facebook',
      'Stripe'
    )
  ];

  useEffect(() => {
    if (isLoading) {
      setRows(rowsLoading);
      // setUnsplashPhotos(unsplashLoading);
      setShowBlock(true);
    }
    if (!isLoading && !error && ordersData && ordersData.items) {
      setTotal(ordersData.total);
      if (ordersData.total == 0) {
        setShowBlock(false);
      } else {
        setShowBlock(true);
      }
      const data = ordersData.items.map((order) => {
        setCurrency(order.currency);
        let image = '';
        let imgStatus = false;
        let description = '';
        let price = order.amount;
        let currencySymbol = order.currency;
        if (order.offer) {
          if (order.offer.image) {
            image = order.offer.image;
            imgStatus = true;
          }
          if (order.offer.description) {
            description = order.offer.description;
          }
          if (order.offer.price) {
            price = order.offer.price;
            currencySymbol = order.offer.currencySymbol;
          }
        }

        const inputDateString = order.createdAt;
        const inputDate = new Date(inputDateString);
        const formattedDate = `${inputDate.getDate()}.${(inputDate.getMonth() + 1).toString().padStart(2, '0')}.${inputDate.getFullYear()}`;
        return createData(
          true,
          '',
          image,
          imgStatus,
          description,
          `${currencySymbol}${price}`,
          formattedDate,
          order.statusPipeline,
          'Facebook',
          order.paymentPlatform
        );
      });
      setRows(data);
    }
  }, [isLoading, error, ordersData]);

  useEffect(() => {
    if (!ordersStatLoading && !statError && ordersStatData) {
      setPreOrder(ordersStatData.preOrder);
      setAwaitingPayment(ordersStatData.awaitingPayment);
      setPaid(ordersStatData.paid);
      setDelivery(ordersStatData.delivery);
      setCompleted(ordersStatData.completed);
      setCanceled(ordersStatData.canceled);
      setSales(ordersStatData.sales);
    }
  }, [ordersStatLoading, statError, ordersStatData]);

  return (
    <div className="orders">
      <div className="orders-top">
        <div className="sidebars-tab__title">Orders</div>
        <div className="orders-top-right">
          <div className="orders-top-item">
            <span>Total orders: </span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width={'50rem'} height={'22rem'} />
            ) : (
              <strong>{total}</strong>
            )}
          </div>
          <div className="orders-top-item">
            <span>Total sales: </span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width={'50rem'} height={'22rem'} />
            ) : (
              <strong>
                {sales} {currency}
              </strong>
            )}
          </div>
        </div>
      </div>
      <div className="orders-block">
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M11.258 15.1162C11.4274 14.4399 12.0352 13.9656 12.7324 13.9656H19.2676C19.9648 13.9656 20.5726 14.4399 20.742 15.1162L22.1296 20.6547C22.37 21.6142 21.6444 22.5441 20.6552 22.5441H11.3448C10.3556 22.5441 9.62998 21.6142 9.87038 20.6547L11.258 15.1162Z"
              stroke="black"
              strokeWidth="1.4"
            />
            <path
              d="M13.5026 14.4892C13.5026 13.2694 12.4981 9 16.001 9C19.5037 9 18.4995 13.2694 18.4994 14.4892"
              stroke="black"
              strokeWidth="1.4"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Pre orders</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{preOrder}</strong>
            )}
          </div>
        </div>
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M23.7887 15.9994C23.7887 11.6974 20.3003 8.21016 15.9994 8.21016C11.6974 8.21016 8.21016 11.6974 8.21016 15.9994C8.21016 20.3015 11.6974 23.7887 15.9994 23.7887C20.3003 23.7887 23.7887 20.3015 23.7887 15.9994ZM9.64587 15.9994C9.64587 12.4903 12.4903 9.64587 15.9994 9.64587C19.5079 9.64587 22.353 12.4907 22.353 15.9994C22.353 19.5082 19.5079 22.353 15.9994 22.353C12.4903 22.353 9.64587 19.5086 9.64587 15.9994ZM16.3959 12.7852C16.3959 12.3887 16.0745 12.0674 15.678 12.0674C15.2816 12.0674 14.9602 12.3887 14.9602 12.7852V16.4997C14.9602 16.7924 15.1378 17.0557 15.4091 17.1653L18.9448 18.5937C19.3124 18.7422 19.7308 18.5646 19.8793 18.197C20.0278 17.8294 19.8502 17.411 19.4826 17.2625L16.3959 16.0155V12.7852Z"
              fill="black"
              stroke="black"
              strokeWidth="0.15"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Awaiting Payment</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{awaitingPayment}</strong>
            )}
          </div>
        </div>
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M22.1047 9.9335C21.5656 9.64517 21.0321 9.49531 19.5932 9.49531H12.4057C10.9668 9.49531 10.4333 9.64517 9.89414 9.9335C9.35726 10.2206 8.93547 10.6424 8.64834 11.1793C8.36001 11.7184 8.21016 12.252 8.21016 13.6908V18.3069C8.21016 19.7458 8.36001 20.2793 8.64834 20.8185C8.93547 21.3553 9.35726 21.7771 9.89414 22.0643C10.4333 22.3526 10.9668 22.5025 12.4057 22.5025H19.5932C21.0321 22.5025 21.5656 22.3526 22.1047 22.0643C22.6416 21.7771 23.0634 21.3553 23.3505 20.8185C23.6389 20.2793 23.7887 19.7458 23.7887 18.3069V13.6908C23.7887 12.252 23.6389 11.7184 23.3505 11.1793C23.0634 10.6424 22.6416 10.2206 22.1047 9.9335ZM9.64524 15.431H22.3524L22.353 18.6692V18.6694L22.352 18.8233C22.352 18.8234 22.352 18.8235 22.352 18.8235C22.3416 19.5599 22.2543 19.8393 22.1043 20.1198C21.9432 20.421 21.7072 20.6569 21.406 20.818C21.1071 20.9779 20.8093 21.0667 19.9557 21.0667H12.0434H12.0432L11.8893 21.0657C11.8892 21.0657 11.8892 21.0657 11.8891 21.0657C11.1527 21.0553 10.8733 20.968 10.5929 20.818C10.2916 20.6569 10.0557 20.421 9.8946 20.1198C9.73471 19.8208 9.64587 19.523 9.64587 18.6694L9.64524 15.431ZM13.1345 17.3043C13.0148 17.2403 12.8936 17.2096 12.6215 17.2096H12.306C12.0339 17.2096 11.9127 17.2403 11.7929 17.3043C11.6751 17.3673 11.5822 17.4603 11.5192 17.5781C11.4551 17.6979 11.4244 17.819 11.4244 18.0911V18.4066C11.4244 18.6787 11.4551 18.7999 11.5192 18.9197C11.5822 19.0375 11.6751 19.1304 11.7929 19.1934C11.9127 19.2575 12.0339 19.2882 12.306 19.2882H12.6215C12.8936 19.2882 13.0148 19.2575 13.1345 19.1934C13.2523 19.1304 13.3453 19.0375 13.4083 18.9197C13.4723 18.7999 13.503 18.6787 13.503 18.4066V18.0911C13.503 17.819 13.4723 17.6979 13.4083 17.5781C13.3453 17.4603 13.2523 17.3673 13.1345 17.3043ZM12.0432 10.931H19.9555H19.9557L20.1095 10.9321C20.1096 10.9321 20.1097 10.9321 20.1098 10.9321C20.8462 10.9424 21.1256 11.0298 21.406 11.1798C21.7072 11.3408 21.9432 11.5768 22.1043 11.878C22.2642 12.1769 22.353 12.4747 22.353 13.328C22.353 13.3281 22.353 13.3282 22.353 13.3283L22.3529 13.3525H9.64572L9.64587 13.3289L9.64587 13.3288L9.64691 13.1745C9.64691 13.1744 9.64691 13.1743 9.64691 13.1742C9.65728 12.4378 9.7446 12.1585 9.8946 11.878C10.0557 11.5768 10.2916 11.3408 10.5929 11.1798C10.8918 11.0199 11.1896 10.931 12.0432 10.931Z"
              fill="black"
              stroke="black"
              strokeWidth="0.15"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Payed</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{paid}</strong>
            )}
          </div>
        </div>
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M22.603 21.0799L22.603 21.0799C22.9465 20.9238 23.1286 20.8126 23.3094 20.6364C23.4866 20.4636 23.6183 20.2591 23.7023 20.0262C23.7879 19.7887 23.8137 19.5769 23.8137 19.1996V12.5457C23.8137 12.1684 23.7879 11.9566 23.7023 11.7191C23.6183 11.4862 23.4866 11.2817 23.3094 11.1089C23.1286 10.9327 22.9465 10.8215 22.603 10.6654L17.0866 8.15796C16.7399 8.00036 16.5588 7.93542 16.3343 7.89511C16.1096 7.85475 15.8892 7.85475 15.6645 7.89511C15.4683 7.93036 15.3053 7.98437 15.0348 8.10311L15.0348 8.10311L15.0337 8.10363L9.39591 10.6654L9.39589 10.6654C9.05243 10.8215 8.87028 10.9327 8.68951 11.1089C8.51224 11.2817 8.38058 11.4862 8.29663 11.7191C8.22182 11.9266 8.19256 12.1145 8.18643 12.4119L8.18641 12.4119L8.18641 12.4139L8.18516 19.1996V19.1996C8.18516 19.5769 8.21102 19.7887 8.29663 20.0262C8.38058 20.2591 8.51224 20.4636 8.68951 20.6364C8.87028 20.8126 9.05243 20.9238 9.39589 21.0799L14.9122 23.5873C15.259 23.7449 15.4401 23.8099 15.6645 23.8502C15.8892 23.8905 16.1096 23.8905 16.3343 23.8502C16.5306 23.8149 16.6936 23.7609 16.9641 23.6422L16.9641 23.6422L16.9652 23.6416L22.603 21.0799ZM15.2565 15.3826L15.2566 22.1118L10.0107 19.7273C9.79335 19.6285 9.7576 19.6027 9.72656 19.5725L9.65676 19.6441L9.72656 19.5724C9.71107 19.5574 9.70275 19.5448 9.69534 19.5252L9.68372 19.4846C9.67674 19.4497 9.67224 19.3943 9.67115 19.2692C9.67115 19.2691 9.67114 19.269 9.67114 19.2688L9.67088 12.8477L15.16 15.3428L15.16 15.3429L15.1633 15.3442L15.2565 15.3826ZM22.328 12.8471V19.1996C22.328 19.4383 22.3193 19.4816 22.3046 19.5224L22.3987 19.5563L22.3046 19.5224C22.2972 19.5427 22.2893 19.5554 22.2745 19.5703L22.2433 19.5969L22.2281 19.6074C22.1901 19.6319 22.1258 19.6648 21.9882 19.7273L16.7423 22.1118L16.743 15.3834C16.7752 15.3707 16.8072 15.3572 16.8389 15.3428L16.8389 15.3428L22.328 12.8471ZM16.4718 9.51051L21.2754 11.694L19.5352 12.4849L14.2587 10.0863L15.527 9.51053L15.527 9.51051C15.7832 9.39406 15.8538 9.3706 15.9272 9.35743C15.9775 9.34839 16.0196 9.34827 16.0698 9.35708L16.1237 9.36909L16.1522 9.37744C16.2144 9.39721 16.3022 9.43338 16.4718 9.51051ZM15.7748 13.9902L15.7334 14.0813L15.7748 13.9902L10.7228 11.694L12.4637 10.9026L17.7397 13.3012L16.2269 13.989L16.1589 14.015C16.0329 14.0537 15.8962 14.0454 15.7748 13.9902Z"
              fill="black"
              stroke="black"
              strokeWidth="0.2"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Delivery</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{delivery}</strong>
            )}
          </div>
        </div>
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M14.0723 18.7359L10.7758 15.4394C10.4661 15.1297 9.96412 15.1297 9.65449 15.4394C9.34486 15.749 9.34486 16.251 9.65449 16.5606L13.5116 20.4178C13.8213 20.7274 14.3233 20.7274 14.6329 20.4178L22.3472 12.7035C22.6568 12.3939 22.6568 11.8919 22.3472 11.5822C22.0376 11.2726 21.5355 11.2726 21.2259 11.5822L14.0723 18.7359Z"
              fill="black"
              stroke="black"
              strokeWidth="0.3"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Completed</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{completed}</strong>
            )}
          </div>
        </div>
        <div className="orders-block-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F2F4F6" />
            <path
              d="M10.9396 10.9377L10.9394 10.9375L10.9333 10.9445L10.8798 11.005L10.8796 11.0048L10.8738 11.0122C10.6319 11.3234 10.6538 11.7731 10.9396 12.059C10.9396 12.059 10.9396 12.059 10.9396 12.059L14.8785 15.9983L10.9396 19.9377C10.9396 19.9377 10.9396 19.9377 10.9396 19.9377C10.63 20.2473 10.63 20.7493 10.9396 21.059L10.9394 21.0592L10.9464 21.0653L11.007 21.1188L11.0068 21.119L11.0142 21.1248C11.3253 21.3667 11.775 21.3449 12.0609 21.059C12.0609 21.059 12.0609 21.059 12.0609 21.059L16.0003 17.1201L19.9396 21.059C19.9396 21.059 19.9396 21.059 19.9397 21.059C20.2493 21.3686 20.7513 21.3686 21.0609 21.059L21.0611 21.0592L21.0673 21.0522L21.1208 20.9916L21.121 20.9918L21.1267 20.9844C21.3687 20.6733 21.3468 20.2236 21.0609 19.9377L17.122 15.9983L21.0609 12.059C21.0609 12.059 21.0609 12.059 21.0609 12.059C21.3705 11.7493 21.3705 11.2473 21.0609 10.9377L21.0611 10.9375L21.0541 10.9313L20.9936 10.8778L20.9938 10.8776L20.9864 10.8719C20.6752 10.6299 20.2255 10.6518 19.9396 10.9377L16.0003 14.8766L12.0609 10.9377C12.0609 10.9377 12.0609 10.9377 12.0609 10.9377C11.7513 10.6281 11.2493 10.6281 10.9396 10.9377Z"
              fill="black"
              stroke="black"
              strokeWidth="0.3"
            />
          </svg>

          <div className="orders-block-item-info">
            <span>Canceled</span>
            {ordersStatLoading ? (
              <Skeleton variant="rounded" width="100%" height={26} />
            ) : (
              <strong>{canceled}</strong>
            )}
          </div>
        </div>
      </div>
      <div className="table">
        <div className="table-top">
          <div className="table-top-right">
            <SelectCustom
              sorts={sorts}
              onSelectChange={handleSelectChange}
              defaultValue={defaultValue}
            />
          </div>
        </div>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            {showBlock ? (
              <>
                {' '}
                <TableHead>
                  <TableRow>
                    {/* <TableCell className="table-head-cell">ID</TableCell> */}
                    <TableCell className="table-head-cell">Details</TableCell>
                    <TableCell className="table-head-cell">Amount</TableCell>
                    <TableCell className="table-head-cell">Date</TableCell>
                    <TableCell className="table-head-cell">Sales pipeline</TableCell>
                    {/* <TableCell className="table-head-cell">Source</TableCell> */}
                    <TableCell className="table-head-cell">Payment Method</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow>
                      {/* <TableCell className="table-body-cell" component="th" scope="row" align='center'>
                                        <div className="table-order-id">
                                            {row.id ? <div className={`icon-red`}></div> : null}
                                            {row.id}
                                        </div>

                                    </TableCell> */}
                      <TableCell className="table-product-wrap table-body-cell">
                        {isLoading ? (
                          <Skeleton variant="rounded" width={'332rem'} height={'60rem'} />
                        ) : (
                          <div className="table-product">
                            {row.imgStatus ? (
                              <img src={`${row.img}`} alt="" />
                            ) : (
                              <div className="table-product__img">CC</div>
                            )}
                            <p>{row.name}</p>
                          </div>
                        )}
                      </TableCell>
                      <TableCell className="table-body-cell">
                        {isLoading ? (
                          <Skeleton variant="rounded" width={'100rem'} height={'20rem'} />
                        ) : (
                          <div>{row.amount}</div>
                        )}
                      </TableCell>
                      <TableCell className="table-body-cell">
                        {isLoading ? (
                          <Skeleton variant="rounded" width={'100rem'} height={'20rem'} />
                        ) : (
                          <div>{row.date}</div>
                        )}
                      </TableCell>
                      <TableCell className="table-body-cell">
                        {isLoading ? (
                          <Skeleton variant="rounded" width={'100rem'} height={'20rem'} />
                        ) : (
                          <div> {row.sales}</div>
                        )}
                      </TableCell>
                      {/* <TableCell className="table-body-cell">{row.source}</TableCell> */}
                      <TableCell className="table-body-cell">
                        {isLoading ? (
                          <Skeleton variant="rounded" width={'100rem'} height={'20rem'} />
                        ) : (
                          <div>{row.payment}</div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </>
            ) : null}
          </Table>
        </TableContainer>
        {showBlock ? (
          <div className="table-bottom">
            <div className="pagination">
              <Stack spacing={2}>
                <Pagination
                  count={pages}
                  siblingCount={1}
                  page={activePage}
                  onChange={handlePageChange}
                  renderItem={(item) => (
                    <PaginationItem slots={{ previous: ArrowBack, next: ArrowNext }} {...item} />
                  )}
                />
              </Stack>

              <div className="pagination__page">20/Page</div>
            </div>
          </div>
        ) : (
          <div className="empty">
            <span>No data found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
